module.exports = __webpack_public_path__ + "static/media/tarro_icon.3312c8ae.png";